export const MIGRATION_MESSAGES = {
  IN_PROGRESS:
    "The process will take some time. You will see new version dashboard when its done.",
};
